import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "seu plano foi cancelado". O subject e o proprio
 * destinatario (User); o nome do plano vem de content() (data) para montar o
 * texto e o excerpt.
 */
export default class PlanCancelledNotification extends Notification {
  icon() {
    return 'fas fa-circle-xmark';
  }
  href() {
    return app.route('marketplace.plans');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.plan_cancelled', {
      plan: data.plan_name
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.plan_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/PlanCancelledNotification', PlanCancelledNotification);